<template>
  <div id="SupplierIndex">
    <!-- <div style="padding: 10px; border-bottom: solid 1px #969799">
      <van-form action="">
        <van-field
          v-model="keywords"
          type="search"
          @search="onSearch"
          placeholder="供应商名称"
          clearable
          class="search"
        />
      </van-form>
    </div> -->
    <van-list
      v-model:loading="loading"
      :finished="finished"
      :finished-text="finishedText"
      @load="onLoad"
      style="margin-bottom: 50px"
    >
      <van-cell v-for="(item, index) in supplierLists" :key="index">
        <div class="box">
          <van-image style="width: 100px; height: 100px;" :src="item.shopLogo">
            <template v-slot:error
              ><van-image
                width="100"
                height="100"
                :src="require('@/assets/images/supplier_default_logo.jpeg')"
            /></template>
          </van-image>
          <div style="margin-left: 20px; width: 100%">
            <p style="font-size: 18px">{{ item.shopName }}</p>
            <p style="font-size: 12px" class="description">
              {{ item.description ? item.description : '暂无介绍' }}
            </p>
            <p
              class="footer">
              <van-tag type="primary"
                ><van-icon name="phone-o" /><a style="color: #ffffff;" href="tel:{{ item.mobile }}">{{ item.mobile }}</a></van-tag
              >
              <van-button @click="shopDetail(item.shopId)" style="margin-left: 10px" type="primary" size="small"
                >我要选货</van-button
              >
            </p>
          </div>
        </div>
      </van-cell>
    </van-list>
    <CommonTabbar :tabbarActive="tabbarActive"></CommonTabbar>
  </div>
</template>

<script>
export default {
  name: 'SupplierIndex',
  data() {
    return {
      keywords: '',
      loading: false,
      finished: false,
      finishedText: '',
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      supplierLists: [],
      tabbarActive: 0,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    onSearch() {
      this.pageNumber = 1
      this.supplierLists = []
      this.getData()
    },
    getData() {
      this.$axios
        .post(
          this.$axios.defaults.baseURL + '/market/supplier/lists',
          {
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
            keywords: this.keywords,
          },
          {}
        )
        .then((response) => {
          let rows = response.data.data.items //请求返回当页的列表
          this.loading = false
          this.total = response.data.data.total
          if (rows == null || rows.length === 0) {
            // 加载结束
            this.finished = true
            this.finishedText = '——————我是有底线的——————'
            return
          }
          // 将新数据与老数据进行合并
          this.supplierLists = this.supplierLists.concat(rows)
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.pageNumber == response.data.data.pages) {
            this.finished = true
            this.finishedText = '——————我是有底线的——————'
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data)
            console.log(error.response.status)
            console.log(error.response.headers)
          } else if (error.request) {
            if (error.request.status == 0) {
              this.$toast('服务器溜号了，赶快召唤神龙大侠阿宝～')
            }
          } else {
            console.log('Error', error.message)
          }
        })
    },
    shopDetail(shopId) {
      console.log(shopId)
      this.$router.replace('/supplier/detail/id/' + shopId)
    },
    onLoad() {
      this.pageNumber++
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.search {
  color: #333333;
  background-color: #e6e7e8;
  border-radius: 10px;
}
.box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.description {
  color: #969799;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  height: 4em;
}
.footer {
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
}
</style>